import { useTranslation } from 'react-i18next'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type Locale } from '../i18n'

const LABELS: Record<Locale, string> = {
  en: 'EN',
  ja: '日本語',
}

/**
 * Minimal locale switcher. Persists via i18next localStorage detector ('atsm.locale').
 * Drop <LanguageSwitcher /> into any header/toolbar.
 */
export function LanguageSwitcher({ className }: { className?: string }) {
  const { i18n, t } = useTranslation()
  const current = (i18n.resolvedLanguage || i18n.language || DEFAULT_LOCALE) as Locale

  return (
    <label className={className} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <span className="sr-only">{t('common.language')}</span>
      <select
        aria-label={t('common.language')}
        value={SUPPORTED_LOCALES.includes(current) ? current : DEFAULT_LOCALE}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
      >
        {SUPPORTED_LOCALES.map((loc) => (
          <option key={loc} value={loc}>
            {LABELS[loc]}
          </option>
        ))}
      </select>
    </label>
  )
}

export default LanguageSwitcher
